import React from 'react';
import styled, { ColorsTypes } from 'styled-components';

import { ReactComponent as LoadingIcon } from 'app/images/loading.svg';

const LoadingSpinner = styled(LoadingIcon)`
  circle {
    stroke: ${(props: any) => props.theme.colors[props['data-color']]} !important;
  }
`;

interface SpinnerProps {
  color?: ColorsTypes;
}

const Spinner = ({ color = 'white' }: SpinnerProps) => {
  return <LoadingSpinner data-color={color} />;
};

export default Spinner;
